export default __webpack_public_path__ + "static/media/6.8f985871.gif";